// Core packages
import {
  HttpClient,
  HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";

// Third party packages
import { EMPTY, Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

// Custom packages
import { CustomAddress } from 'src/app/shared/interfaces/address.interface';
import { ConfigService } from "./config.service";

@Injectable({
  providedIn: "root"
})
export class GoogleapiService {
  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private http: HttpClient,
  ) {
  }

  
   /**
   * Get Google Geocoding by address
   * 
   * @param address Address
   * 
   * @returns object|null The geocoding data found or null
   */
   public getGeocoding(address: CustomAddress): Observable<any> {
    try {
      return new Observable<any>(obs => {
        let textAddress = `${address.route}+${address.streetNumber}+${address.postalCode}+${address.city}`;
        textAddress = encodeURIComponent(textAddress);
        
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${textAddress}&key=${this.configService.googleMapsApi}`;
        this.http
          .get(url)
          .pipe(catchError(this.handleError))
          .subscribe(
            (res) => {
              if (
                res &&
                res.status === "OK"
              ) {
                obs.next(res.results);
              } else {
                obs.next();
              }
            },
            (error) => {
              console.warn(error);
              return obs.error(error);
            },
            () => {
              return obs.complete();
            }
          );
      });
    } catch (error) {
      console.warn(error);
      return EMPTY;
    }
  }

  /**
   * Handle http errors
   *
   * @since 1.0.0
   */
  private handleError(error: HttpErrorResponse): Observable<any> {
    // const message = error.error.message;
    // if (typeof context.toastrService !== 'undefined') {
    //   context.toastrService.error(message);
    // }
    if (error.status === 0) {
      return of(
        new Error("Unexpected error. Please reload the page and try again")
      );
    }
    return throwError(error);
  }
}
